// This instrument import should remain here
// eslint-disable-next-line
import './sentry-instrument';
import './index.css';
import SentryBoundary from '@/components/sentry-boundary/SentryBoundary';

import { ChakraProvider } from '@chakra-ui/react';
import { enableMapSet } from 'immer';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import App from '@/App';
import UserPassport from '@/components/user-passport/UserPassport';
import AuthProvider from '@/Providers/Auth.provider';
import LDProviderWrapper from '@/Providers/LDProviderWrapper';
import Pendo from '@/utils/Pendo';

import { store } from './store/store';

enableMapSet();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ChakraProvider>
      <CookiesProvider>
        <Provider store={store}>
            <BrowserRouter>
              <SentryBoundary>
                <AuthProvider>
                  <UserPassport>
                    <LDProviderWrapper>
                      <Pendo />
                      <App />
                    </LDProviderWrapper>
                  </UserPassport>
                </AuthProvider>
              </SentryBoundary>
            </BrowserRouter>
        </Provider>
      </CookiesProvider>
    </ChakraProvider>
  </React.StrictMode>,
);
